import { ReportsService } from './reports-service'

let reportsService = new ReportsService();

export { reportsService }